import { useEffect, useState, FormEvent, useRef, useCallback } from "react";
import Button from "../../reusable/Button";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addMonths } from "date-fns";
import { registerLocale } from "react-datepicker";
import { fr } from "date-fns/locale/fr";
import "./index.style.css";
import axios from "axios";
import Swal from "sweetalert2";
import { parseDateFromString, formatDateToNewFormat, formatDateToOldFormat, normalizeDateString } from "../../../lib/dateUtils";

registerLocale("fr", fr);

const ADMIN_EMAIL = "voicugeorgiana88@gmail.com";

function AppointmentAlert({ reservedDates, formData, selectedData, onClose }: any) {
  const telLink = "tel:023545798";
  const emailLink = "mailto:esthetiquebasilix@gmail.com";

  const normalizeDate = useCallback((dateStr: string): string => {
    return normalizeDateString(dateStr);
  }, []);

  const selectedDate = selectedData ? parseDateFromString(selectedData) : null;

  // Doar programările viitoare (azi sau mai târziu) contează pentru alertă.
  // O programare deja efectuată în aceeași lună nu trebuie afișată ca blocantă.
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const reservedDate = reservedDates.find((item: any) => {
    try {
      const itemDate = parseDateFromString(item.data);
      if (!itemDate || !selectedDate) return false;
      if (itemDate.getTime() < today.getTime()) return false;
      return (
        itemDate.getMonth() === selectedDate.getMonth() &&
        itemDate.getFullYear() === selectedDate.getFullYear() &&
        item.email?.toLowerCase() === formData?.toLowerCase()
      );
    } catch {
      return false;
    }
  })?.data;

  return (
    <div className="appointment-alert-overlay" onClick={onClose}>
      <div
        className="appointment-alert-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <h2>Rendez-vous existant</h2>
        <p>
          Vous avez déjà un rendez-vous ce mois-ci
          {reservedDate ? (
            <> pour la date <span className="bold">{normalizeDate(reservedDate)}</span></>
          ) : null}
          .
        </p>
        <p>
          Une seule réservation par mois est autorisée. Si vous souhaitez modifier
          votre rendez-vous, veuillez contacter l'administrateur :
        </p>
        <p>
          📞{" "}
          <a href={telLink} className="link">
            02 354 57 98
          </a>
        </p>
        <p>
          ✉{" "}
          <a href={emailLink} className="link">
            esthetiquebasilix@gmail.com
          </a>
        </p>

        <button onClick={onClose} className="close-btn">
          Fermer
        </button>
      </div>
    </div>
  );
}



interface Reservation {
  name: string;
  surname: string;
  tel: string;
  email: string;
  service: string;
  data: string;
  time: string;
}

const services = [
  "Lifting HIFU",
  "RADIANCE - Traitement à l'ADN de saumon",
  "Peeling acide",
  "ESSENTIEL - Soin du Visage",
  "GOLD - Soin du Visage par Hydrafacial Diamant",
  "DIAMOND - Soin du Visage par Hydrafacial Diamant",
  "PLATINUM - Soin du Visage par Hydrafacial Diamant",
  "Mésothérapie",
  "Peeling Laser",
  "Dépigmentation des sourcils et tatouages avec Pico-Laser",
  "Dépigmentation des taches avec Pico-Laser",
  "Épilation définitive",
  "Épilation à la cire",
  "Élimination au laser des varices fines et de la cupérose",
  "Cryothérapie",
  "Remodelage Corporel",
  "Raffermissement Corporel par HIFU",
  // "Massage thérapeutique",
];

// Label-uri doar pentru afișare în dropdown; payload-ul trimite întotdeauna valoarea din services (fără label).
const serviceDisplayLabels: Record<string, string> = {
};

// Servicii blocate până pe 15 septembrie
const blockedServices: string[] = ["Raffermissement Corporel par HIFU"];

const times = [
  "10h00",
  "11h00",
  "12h00",
  "13h00",
  "14h00",
  "15h00",
  "16h00",
  "17h00",
  "18h00",
];

export default function Form() {
  const [reservedDates, setReservedDates] = useState<Reservation[]>([]);
  const [formData, setFormData] = useState<{
    name: string;
    surname: string;
    tel: string;
    email: string;
    service: string;
    data: string;
    time: string;
  }>({
    name: "",
    surname: "",
    tel: "",
    email: "",
    service: "",
    data: "",
    time: "",
  });
  const [disableBtn, setDisableBtn] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupState, setPopupState] = useState<"question" | "denied">(
    "question"
  );
  const [showAppointmentAlert, setShowAppointmentAlert] = useState(false);
  // Starea backend-ului: "unknown" = încă se verifică, "loading" = nu răspunde (cold-start
  // pe Render), "ready" = a răspuns și avem disponibilitățile reale.
  const [serverStatus, setServerStatus] = useState<"unknown" | "loading" | "ready">("unknown");

  let isDisabled;
  const serviceSelectRef = useRef<HTMLSelectElement>(null);
  const [highlighted, setHighlighted] = useState(false);
  const highlightTimeout = useRef<NodeJS.Timeout | null>(null);
  // Ref pentru a accesa mereu formData curent din efecte fără stale closure
  const formDataRef = useRef(formData);

  // Verifică dacă serviciul este blocat până pe 15 septembrie
  const isServiceBlocked = (service: string): boolean => {
    // Verifică dacă serviciul este în lista de servicii blocate
    if (!blockedServices.includes(service)) {
      return false;
    }
    
    // Verifică dacă data curentă este înainte de 15 septembrie din anul curent
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const september15 = new Date(currentYear, 8, 15); // Septembrie este luna 8 (0-indexed)
    
    // Dacă data curentă este după 15 septembrie, serviciul nu mai este blocat
    return currentDate < september15;
  };


  const getReservedDates = async () => {
    try {
      const response = await axios.get(
        "https://esthetiquebasilixbackend.onrender.com/tasks/get",
        { timeout: 12000 }
      );
      setReservedDates(response.data);
      setServerStatus("ready");
      return true;
    } catch (error) {
      console.error("Error fetching tasks:", error);
      // Backend-ul probabil doarme (Render free tier face cold-start). Marcăm "loading"
      // ca să afișăm mesajul de așteptare și să reîncercăm până pornește.
      setServerStatus("loading");
      return false;
    }
  };

  // Sincronizează ref-ul la fiecare render pentru efecte care nu trebuie să re-ruleze la schimbare
  useEffect(() => {
    formDataRef.current = formData;
  });

  useEffect(() => {
    getReservedDates();
  }, []);

  useEffect(() => {
    getReservedDates();
  }, [formData.data, formData.service]);

  // Polling live: actualizează orele disponibile la fiecare 30 secunde când userul are o dată selectată
  useEffect(() => {
    if (!formData.data) return;
    const interval = setInterval(getReservedDates, 30000);
    return () => clearInterval(interval);
  }, [formData.data]);

  // Cold-start Render: cât timp backend-ul nu răspunde, reîncearcă la fiecare 4 secunde
  // până pornește. La primul GET reușit, serverStatus devine "ready" și intervalul se oprește.
  useEffect(() => {
    if (serverStatus !== "loading") return;
    const interval = setInterval(getReservedDates, 4000);
    return () => clearInterval(interval);
  }, [serverStatus]); // eslint-disable-line react-hooks/exhaustive-deps

  // Dacă ora selectată de user devine rezervată după un refresh (altcineva a rezervat-o), curăță automat selecția
  useEffect(() => {
    const { time, data } = formDataRef.current;
    if (!time || !data) return;
    const isNowTaken = reservedDates.some(
      (r) =>
        normalizeDateString(r.data) === normalizeDateString(data) &&
        r.time === time
    );
    if (isNowTaken) {
      setFormData((prev) => ({ ...prev, time: "" }));
      Swal.fire({
        title: "Désolé !",
        text: "L'heure que vous aviez sélectionnée vient d'être réservée par un autre client. Veuillez choisir une autre heure disponible.",
        icon: "warning",
        confirmButtonText: "OK",
        width: "500px",
        customClass: { popup: "custom-alert" },
      });
    }
  }, [reservedDates]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const handler = (e: any) => {
      if (e.detail && e.detail.service) {
        setFormData((prev) => ({ ...prev, service: e.detail.service, time: "" }));
        setHighlighted(false); // Reset highlight immediately
        if (highlightTimeout.current) clearTimeout(highlightTimeout.current);
        setTimeout(() => setHighlighted(true), 10); // Re-trigger highlight
        highlightTimeout.current = setTimeout(() => setHighlighted(false), 2000);
      }
    };
    window.addEventListener("highlightService", handler);
    return () => window.removeEventListener("highlightService", handler);
  }, []);

const handleSubmit = async () => {
  setDisableBtn(true);
  try {
    const res = await axios.post(
      "https://esthetiquebasilixbackend.onrender.com/tasks/save",
      {
        data: formatDateToOldFormat(formData.data),
        email: formData.email,
        name: formData.name,
        service: formData.service,
        surname: formData.surname,
        tel: formData.tel,
        time: formData.time,
      }
    );

    // Programarea e salvată în DB. DOAR ACUM construim butonul de adăugare în calendar.
    // Pentru TOATE dispozitivele (iOS + Android + desktop) → Google Agenda: clientul e
    // redirecționat la Google Calendar cu evenimentul pre-completat și apasă doar „Save".
    let calendarHtml = "";
    const googleUrl: string | undefined = res?.data?.googleCalendarUrl;
    if (googleUrl) {
      calendarHtml = `
        <div style="margin-top:18px;display:flex;justify-content:center;">
          <a href="${googleUrl}" target="_blank" rel="noopener"
             style="display:inline-block;background:#97afbc;color:#fff;padding:12px 24px;border-radius:8px;text-decoration:none;font-weight:600;font-size:15px;">
            📅 Ajouter à mon calendrier
          </a>
        </div>`;
    }

    // Emailul de confirmare (cu .ics atașat) este trimis de backend după confirmarea din DB
    Swal.fire({
      title: "Inscription réussie !",
      html: `
        <p><b>Un message de confirmation a été envoyé à l'adresse e-mail indiquée. Si celui-ci tarde à arriver, veuillez vérifier le dossier spam.</b></p>
        <p>Merci d'avoir choisi notre centre d'esthétique. Un spécialiste sera présent à la date et à l'heure que vous avez choisies pour vous offrir nos services de la meilleure qualité. Cela signifie la préparation des instruments, des produits, etc.</p>
        <p>C'est pourquoi nous vous prions de respecter le rendez-vous que vous avez pris et d'annoncer tout changement au moins 24 heures avant le jour et l'heure fixés.</p>
        <p>Merci. À bientôt !</p>
        ${calendarHtml}
      `,
      icon: "success",
      confirmButtonText: "OK",
      width: "600px",
      customClass: { popup: "custom-alert" },
    });

    setFormData({
      name: "",
      surname: "",
      tel: "",
      email: "",
      service: "",
      data: "",
      time: "",
    });
    getReservedDates();
  } catch (error: any) {
    console.error("Booking error:", error);
    if (error?.response?.status === 409) {
      Swal.fire({
        title: "Désolé !",
        text: "Cette date et cette heure viennent d'être réservées par un autre client. Veuillez choisir une autre heure disponible.",
        icon: "warning",
        confirmButtonText: "OK",
        width: "500px",
        customClass: { popup: "custom-alert" },
      });
      setFormData((prev) => ({ ...prev, time: "" }));
      getReservedDates();
    } else {
      Swal.fire({
        title: "Erreur !",
        text: "Une erreur s'est produite lors de l'enregistrement de votre rendez-vous. Veuillez réessayer ou nous contacter au 023545798.",
        icon: "error",
        confirmButtonText: "OK",
        width: "500px",
        customClass: { popup: "custom-alert" },
      });
    }
  } finally {
    setDisableBtn(false);
  }
};

  const handleFormSubmitAttempt = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (formData.service === "Massage thérapeutique") {
      handleSubmit();
    } else {
      setPopupState("question");
      setShowPopup(true);
    }
  };

  const handlePopupYes = () => {
    setShowPopup(false);
    handleSubmit();
  };

  const handlePopupNo = () => {
    setPopupState("denied");
  };

  const handlePopupClose = () => {
    setShowPopup(false);
  };

  // Folosim funcțiile centralizate din dateUtils
  const normalizeDate = useCallback((dateStr: string): string => {
    return normalizeDateString(dateStr);
  }, []);

  const dataToString = (data: Date | null | string): string => {
    return formatDateToNewFormat(data);
  };

  const isWeekday = (date: Date) => {
    const day = date.getDay();
    
    // Allow Sunday, October 19th specifically
    const october19 = new Date(2025, 9, 19); // October 19, 2025 (month is 0-indexed)
    const isOctober19 = date.getFullYear() === october19.getFullYear() &&
                        date.getMonth() === october19.getMonth() &&
                        date.getDate() === october19.getDate();
    
    // If it's October 19th, allow it even though it's Sunday
    if (isOctober19) {
      return true;
    }
    
    // For all other dates, disable Sundays
    return day !== 0;
  };

  useEffect(() => {
    if (formData.email.toLowerCase() === ADMIN_EMAIL.toLowerCase()) {
      setDisableBtn(false);
      setShowAppointmentAlert(false);
      return;
    }

    if (!formData.data || !formData.email) {
      setDisableBtn(false);
      setShowAppointmentAlert(false);
      return;
    }

    const selectedDate = parseDateFromString(formData.data);
    if (!selectedDate) {
      setDisableBtn(false);
      setShowAppointmentAlert(false);
      return;
    }

    const selectedMonth = selectedDate.getMonth();
    const selectedYear = selectedDate.getFullYear();

    // Programările din trecut nu mai blochează o rezervare nouă. Altfel, un client
    // care a venit deja la o procedură pe 01.10.2026 ar rămâne blocat toată luna
    // octombrie 2026, deși programarea respectivă a fost efectuată.
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const hasBookingInSelectedMonth = reservedDates.some((item) => {
      try {
        const itemDate = parseDateFromString(item.data);
        if (!itemDate) return false;
        if (itemDate.getTime() < today.getTime()) return false;
        return (
          itemDate.getMonth() === selectedMonth &&
          itemDate.getFullYear() === selectedYear &&
          item.email.toLowerCase() === formData.email.toLowerCase()
        );
      } catch {
        return false;
      }
    });

    if (hasBookingInSelectedMonth) {
      setDisableBtn(true);
      setShowAppointmentAlert(true);
    } else {
      setDisableBtn(false);
      setShowAppointmentAlert(false);
    }
  }, [formData.email, formData.data, reservedDates]);

  // Verifică dacă data este o miercuri începând cu iunie 2026 (toate orele blocate)
  const isWednesdayBlockedFromJune2026 = (dateStr: string): boolean => {
    if (!dateStr) return false;
    try {
      const selectedDate = parseDateFromString(dateStr);
      if (!selectedDate) return false;
      const june1_2026 = new Date(2026, 5, 1); // Iunie este luna 5 (0-indexed)
      selectedDate.setHours(0, 0, 0, 0);
      june1_2026.setHours(0, 0, 0, 0);
      // Miercuri deblocate manual (exceptii de la regula de blocare)
      const allowedWednesdays = [
        new Date(2026, 7, 5).setHours(0, 0, 0, 0),  // 5 august 2026
        new Date(2026, 7, 12).setHours(0, 0, 0, 0), // 12 august 2026
      ];
      if (allowedWednesdays.includes(selectedDate.getTime())) return false;
      return selectedDate.getTime() >= june1_2026.getTime() && selectedDate.getDay() === 3; // 3 = miercuri
    } catch (e) {
      console.error("Error checking Wednesday from June 2026:", e);
      return false;
    }
  };

  // Verifică dacă data este pe sau după 6 ianuarie 2026
  const isOnOrAfterJanuary6_2026 = (dateStr: string): boolean => {
    if (!dateStr) return false;
    
    try {
      const selectedDate = parseDateFromString(dateStr);
      if (!selectedDate) return false;
      
      // 6 ianuarie 2026 specific
      const january6_2026 = new Date(2026, 0, 6); // Ianuarie este luna 0 (0-indexed)
      
      // Setăm orele la 0 pentru comparație corectă
      selectedDate.setHours(0, 0, 0, 0);
      january6_2026.setHours(0, 0, 0, 0);
      
      return selectedDate.getTime() >= january6_2026.getTime();
    } catch (e) {
      console.error("Error checking January 6th 2026 date:", e);
      return false;
    }
  };

  const isTimePast = (
    time: string,
    selectedDateStr: string,
    currentDateStr: string
  ): boolean => {
    if (!selectedDateStr || !time) return false;

    try {
      const [hours] = time.split("h").map(Number);
      if (isNaN(hours)) return false;

      // Folosim funcțiile centralizate pentru parsare
      const selectedDate = parseDateFromString(selectedDateStr);
      const currentDate = parseDateFromString(currentDateStr);
      
      if (!selectedDate || !currentDate) return false;
      
      selectedDate.setHours(0, 0, 0, 0);
      currentDate.setHours(0, 0, 0, 0);

      if (selectedDate.getTime() > currentDate.getTime()) {
        return false;
      }

      if (selectedDate.getTime() === currentDate.getTime()) {
        const now = new Date();
        const currentHour = now.getHours();
        if (hours <= currentHour) {
          return true;
        }
      }

      if (selectedDate.getTime() < currentDate.getTime()) {
        return true;
      }
    } catch (e) {
      console.error("Error parsing date/time in isTimePast:", e);
      return false;
    }

    return false;
  };

  return (
    <section id="form" className="form">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
        <path
          fill="#97afbc"
          fillOpacity="1"
          d="M0,288L60,245.3C120,203,240,117,360,69.3C480,21,600,11,720,16C840,21,960,43,1080,48C1200,53,1320,43,1380,37.3L1440,32L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z"
        ></path>
      </svg>
      <div className="form-main">
        <div className="form-container">
          <h2>Prendre rendez-vous</h2>
          <form
            onSubmit={handleFormSubmitAttempt}
            id="form-element"
            className="flex flex-col"
          >
            <input
              type="text"
              className="form-control"
              value={formData.name}
              placeholder="Nom"
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
              required
            />
            <input
              type="text"
              className="form-control"
              value={formData.surname}
              placeholder="Prénom"
              onChange={(e) =>
                setFormData({ ...formData, surname: e.target.value })
              }
              required
            />
            <input
              type="tel"
              className="form-control"
              value={formData.tel}
              placeholder="GSM"
              onChange={(e) =>
                setFormData({ ...formData, tel: e.target.value })
              }
              required
              // pattern="[0-9\+\-\s]+"
            />
            <input
              type="email"
              className="form-control"
              value={formData.email}
              placeholder="E-mail  (Saisir correctement votre adresse)"
              onChange={
                (e) =>
                  setFormData({ ...formData, email: e.target.value.trim() }) // Trim whitespace
              }
              required
            />
            <select
              ref={serviceSelectRef}
              className={`form-control${highlighted ? " highlight-service" : ""}`}
              value={formData.service}
              onChange={
                (e) =>
                  setFormData({
                    ...formData,
                    service: e.target.value,
                    time: "",
                  }) // Reseteaza ora la schimbarea serviciului
              }
              required={true}
            >
              <option value="">Sélectionner le service</option>
              {services.map((service) => (
                <option
                  key={service}
                  value={service}
                  disabled={
                    service === "Massage thérapeutique" ||
                    (blockedServices.includes(service) && isServiceBlocked(service))
                  }
                >
                  {service}
                  {serviceDisplayLabels[service]
                    ? ` ${serviceDisplayLabels[service]}`
                    : ""}
                </option>
              ))}
            </select>

            {formData.service && serverStatus !== "ready" && (
              <div style={{
                color: "#8a6d3b",
                fontSize: "14px",
                marginBottom: "16px",
                padding: "10px 12px",
                backgroundColor: "#fcf8e3",
                borderRadius: "6px",
                border: "1px solid #faebcc",
                lineHeight: 1.45,
              }}>
                ⏳ Nous nous excusons, le serveur est en cours de démarrage.<br />
                Le chargement des disponibilités peut prendre jusqu'à une minute. Merci de patienter, les créneaux s'afficheront automatiquement…
              </div>
            )}

            <DatePicker
              locale="fr"
              selected={formData.data ? parseDateFromString(formData.data) : null} // Folosește funcția de parsare
              filterDate={isWeekday}
              minDate={
                blockedServices.includes(formData.service) && isServiceBlocked(formData.service) 
                  ? new Date(new Date().getFullYear(), 8, 15) // 15 septembrie din anul curent pentru serviciile blocate
                  : new Date() // Data curentă pentru serviciile normale sau serviciile blocate după 15 septembrie
              }
              excludeDates={[
                new Date("2025-08-15"),
                // Concediu 21-30 iulie 2026
                new Date("2026-07-21"), new Date("2026-07-22"), new Date("2026-07-23"),
                new Date("2026-07-24"), new Date("2026-07-25"), new Date("2026-07-26"),
                new Date("2026-07-27"), new Date("2026-07-28"), new Date("2026-07-29"),
                new Date("2026-07-30"),
                // Concediu 15-25 august 2026
                new Date("2026-08-15"), new Date("2026-08-16"), new Date("2026-08-17"),
                new Date("2026-08-18"), new Date("2026-08-19"), new Date("2026-08-20"),
                new Date("2026-08-21"), new Date("2026-08-22"), new Date("2026-08-23"),
                new Date("2026-08-24"), new Date("2026-08-25"),
              ]}
              maxDate={
                blockedServices.includes(formData.service) && isServiceBlocked(formData.service)
                  ? new Date(new Date().getFullYear(), 9, 31) // 31 octombrie pentru serviciile blocate
                  : addMonths(new Date(), 2) // Maxim 2 luni in avans pentru serviciile normale
              }
              onChange={
                (
                  date: Date | null // Tip corect pentru onChange
                ) =>
                  setFormData({
                    ...formData,
                    data: dataToString(date),
                    time: "",
                  }) // Reseteaza ora la schimbarea datei
              }
              className="form-control"
              placeholderText={
                !formData.service
                  ? "Sélectionnez d'abord un service"
                  : serverStatus !== "ready"
                  ? "Chargement… veuillez patienter"
                  : blockedServices.includes(formData.service) && isServiceBlocked(formData.service)
                  ? "Disponible à partir du 15 septembre"
                  : "Date"
              }
              dateFormat="dd-MM-yyyy" // Format nou: dd-MM-yyyy
              required
              disabled={!formData.service || serverStatus !== "ready"}
            />
            
            {blockedServices.includes(formData.service) && isServiceBlocked(formData.service) && (
              <div style={{
                color: "#e74c3c",
                fontSize: "14px",
              
                marginBottom: "20px",
                padding: "8px",
                backgroundColor: "#fdf2f2",
                borderRadius: "4px",
                border: "1px solid #fecaca"
              }}>
                ⚠️ Ce service sera disponible à partir du 15 septembre 2025.
              </div>
            )}

            <select
              className="form-control"
              value={formData.time}
              onChange={(e) =>
                setFormData({ ...formData, time: e.target.value })
              }
              disabled={serverStatus !== "ready" || !formData.data || !formData.service} // Dezactivat dacă serverul nu e gata SAU nu e selectată data/serviciul
              required
            >
              <option value="">{formData.service && serverStatus !== "ready" ? "Chargement…" : "Heure"}</option>
              {times
                .filter((time) => {
                  // Pentru datele pe sau după 6 ianuarie 2026, ascundem complet orele 10:00 și 11:00
                  if (isOnOrAfterJanuary6_2026(formData.data)) {
                    const [hours] = time.split("h").map(Number);
                    return hours >= 12; // Doar orele de la 12:00 în sus
                  }
                  // Pentru datele înainte de 6 ianuarie 2026, afișăm toate orele
                  return true;
                })
                .map((time) => {
                  const isWednesdayBlocked = isWednesdayBlockedFromJune2026(formData.data);

                  const isReserved = isWednesdayBlocked || reservedDates.some(
                    (reservation) =>
                      normalizeDate(reservation.data) === normalizeDate(formData.data) &&
                      reservation.time === time
                  );

                  const timeHasPassed = !isWednesdayBlocked && isTimePast(
                    time,
                    formData.data,
                    dataToString(new Date())
                  );

                  isDisabled = isReserved || timeHasPassed;

                  return (
                    <option key={time} value={time} disabled={isDisabled}>
                      {time}
                      {isReserved ? " (Réservé)" : ""}
                      {timeHasPassed ? " (Passé)" : ""}
                    </option>
                  );
                })}
            </select>
            <Button
              type="submit"
              title="Prendre rendez-vous"
              disableBtn={disableBtn}
            />
          </form>
        </div>
        <img
          src="https://firebasestorage.googleapis.com/v0/b/esthetiquebasilix-7e531.appspot.com/o/retoques-t.jpg?alt=media&token=24e2a8f3-6244-4db3-97f9-793feb776846"
          alt="..."
        />
      </div>

      {/* --- POPUP --- */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            {popupState === "question" ? (
              <>
                <p>
                  Ce service est exclusivement destiné aux femmes.
                  <br /> <br />
                  Êtes-vous une femme ?
                </p>
                <div className="popup-buttons">
                  <button type="button" onClick={handlePopupYes}>
                    Oui
                  </button>
                  <button type="button" onClick={handlePopupNo}>
                    Non
                  </button>
                </div>
              </>
            ) : (
              <>
                <p>
                  Nous sommes désolés ! <br /> Si vous souhaitez acheter une
                  carte cadeau pour une personne chère, vous pouvez passer
                  commande à l'adresse e-mail:
                  <a
                    href={"mailto:Esthetiquebasilix@gmail.com"}
                    className="contact-info-form"
                  >
                    <div className="contact-text">
                      esthetiquebasilix@gmail.com
                    </div>
                  </a>
                  ou directement dans notre centre au Basilix Shopping Center au
                  deuxième étage. Merci de votre compréhension !
                </p>
                <div className="popup-buttons">
                  <button type="button" onClick={handlePopupClose}>
                    Ferme
                  </button>{" "}
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {showAppointmentAlert && (
        <AppointmentAlert
          reservedDates={reservedDates}
          formData={formData.email}
          selectedData={formData.data}
          onClose={() => setShowAppointmentAlert(false)}
        />
      )}
    </section>
  );
}
